<template>
  <div class="content">
    <div class="container">
      <h1 class="mb-5">
        Import Orders
      </h1>

      <nav-fulfillment :tab="tab" />

      <div
        v-if="$route.query.payment=='success'"
        class="alert bg-white text-success border border-success p-3 mb-3"
      >
        <strong>Thank for payment. ID
          #{{ $route.query.id }}</strong>
      </div>
      <card-box>
        <card-title>Import CSV</card-title>
        <small>Merchant Import Start by uploading your CSV file containing your orders. Make sure it is
          formatted properly
        </small>
        <div class="row">
          <div class="col">
            <div class="form-group mt-3">
              <b-form-file
                ref="filecsv"
                v-model="file"
                class="btn-sm"
                :state="Boolean(file)"
                placeholder="Choose a file .csv"
                drop-placeholder="Drop csv file here..."
                accept=".csv"
              />
            </div>
          </div>
          <div class="col text-right">
            <a
              target="_blank"
              :href="downloadExample()"
              class="btn btn-light mt-3 mr-3 btn-sm"
            ><i
              class="fi-download"
            /> Download Example</a>
            <button
              class="btn btn-light btn-sm mt-3"
              @click="downloadSku()"
            >
              <i class="fi-download" /> Download SKU
            </button>
          </div>
        </div>
      </card-box>

      <card-box>
        <div class="mt-3 row d-flex">
          <div class="col">
            <button
              :disabled="orders.length == 0"
              :class="{'btn-light':step > 1,'btn-success':step==1}"
              class="btn btn-sm mr-3"
              @click="validateSku"
            >
              <i class="fi-check" /> Step 1: Validate
            </button>
            <button
              :disabled="validateOrder == false"
              :class="{'btn-light':step !=2,'btn-success':step==2}"
              class="btn btn-sm mr-3"
              @click="submitOrder"
            >
              <i class="fi-shuffle" /> Step 2: Merge Order
            </button>
            <button
              :disabled="step !=3"
              :class="{'btn-light':step !=3,'btn-success':step==3}"
              class="btn btn-sm mr-3"
              @click="createOrder"
            >
              <i class="fi-printer" /> Step 3: Make Invoice
            </button>
            <button
              title="Download CSV"
              class="float-right btn-sm btn btn-light mr-3"
              @click="downloadCSV"
            >
              <i class="fi-download" /> Download
            </button>
            <button
              class="float-right btn btn-sm btn-light mr-3"
              @click="showAddModal"
            >
              <i
                class="fi-plus"
              /> Order
            </button>
          </div>
        </div>

        <b-progress
          v-if="showProcess"
          class="mt-3"
          :value="processVal"
          :max="this.orders.length"
          show-progress
          animated
        />


        <table
          v-if="step == 1 || invoices.length == 0"
          class="mt-3 table table-hover table-striped w-100 d-block d-table  table-responsive"
        >
          <thead>
            <tr class="header">
              <th />
              <th
                v-for="i in header"
                :key="i"
              >
                {{ i }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in orders"
              class="item"
            >
              <th>
                <i
                  v-if="item.validate == true"
                  class="fi-check text-success"
                />
                <i
                  v-if="item.validate == false"
                  v-b-tooltip.hover
                  :title="item.validate_message"
                  class="fi-cross text-danger"
                />
              </th>
              <td @click="showModal(item)">
                {{ item['order_id'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_name'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_address_1'] }} {{ item['shipping_address_2'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_city'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_state'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_zipcode'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['shipping_country'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['sku'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['size'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['color'] }}
              </td>
              <td @click="showModal(item)">
                {{ item['quantity'] }}
              </td>
              <td>
                <button
                  class="btn btn-sm"
                  @click="remove(item)"
                >
                  <i class="fi-delete text-danger" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>


        <table
          v-if="step == 2 || step ==3"
          class="mt-3 table table-hover table-striped w-100 d-block d-table  table-responsive"
        >
          <thead>
            <tr class="header">
              <th
                v-for="i in headerInvoice"
                :key="i"
              >
                {{ i }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in invoices"
              class="item"
            >
              <td>{{ item['order_id'] }}</td>
              <td>{{ item['shipping_name'] }}</td>
              <td>{{ item['shipping_address_1'] }} {{ item['shipping_address_2'] }}</td>
              <td>{{ item['shipping_city'] }}</td>
              <td>{{ item['shipping_state'] }}</td>
              <td>{{ item['shipping_zipcode'] }}</td>
              <td>{{ item['shipping_country'] }}</td>
              <td>${{ item['total_cost'] }}</td>
              <td>{{ item['quantity'] }}</td>
              <td>${{ item['total_shipping'] }}</td>
            </tr>
          </tbody>
        </table>

        <div
          v-if="orders.length == 0"
          class="w-100 text-center p-5 "
        >
          <h4 class="m-5">
            Not Found
          </h4>
        </div>

        <small
          v-if="step == 1"
          class="text-muted"
        >Please verify all orders to continue!</small>
      </card-box>
    </div>
    <b-modal
      id="modal-order-form"
      ref="modalOrder"
      size="lg"
      class="modal-order"
      hide-footer
      :title="modalTitle"
    >
      <import-order-form
        v-if="item !=null"
        :action="action"
        :item="item"
        @add="add($event)"
        @update="update($event)"
      />
    </b-modal>
  </div>
</template>

<script>
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";
    import NavFulfillment from "../components/NavFulfillment";
    import ImportOrderForm from "../components/ImportOrderForm";

    export default {
        name: "ImportOrder",
        components: {ImportOrderForm, NavFulfillment, CardTitle, CardBox},
        data: function () {
            return {
                design: [],
                processVal: 1,
                waitting: false,
                showProcess: false,
                step: 1,
                validateOrder: false,
                selectedProduct: 0,
                modalTitle: 'Edit Order',
                action: 'edit',
                item: null,
                tab: 'import',
                invoices: [],
                disable: 0,
                filter: {},
                orders: [],
                file: null,
                headerInvoice: ['Order ID', 'Name', 'Address', 'City', 'State', 'Zip', 'Country', 'Total', 'Quantity', 'Shipping'],
                header: ['Order ID', 'Name', 'Address', 'City', 'State', 'Zip', 'Country', 'SKU', 'Size', 'Color', 'Quantity'],
                csvHeader: ['order_id', 'shipping_name', 'shipping_address_1', 'shipping_address_2', 'shipping_city', 'shipping_state', 'shipping_zipcode', 'shipping_country', 'shipping_phone', 'shipping_email', 'sku', 'style', 'size', 'color', 'quantity']
            }
        },
        watch: {
            file: function () {
                if (this.file != null) {
                    this.handleFileUpload()
                    this.$refs.filecsv.reset();
                }
            },

        },

        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'fulfillment')
            this.loadDesign()
            //    this.list()
        },
        methods: {
            downloadExample: function () {
                return this.$config.api + 'example.csv'
            },
            downloadSku: function () {
                this.$http({
                    url: this.$config.api + 'fulfillment/downloadsku',
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sku.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });

            },
            resetFile: function () {
                this.$refs.filecsv.reset();
            },
            createOrder: async function () {
                let vm = this
                this.waitting = true

                await this.$http.post(this.$config.api + 'fulfillment/create', this.invoices).then(function (res) {
                    console.log(res.data)
                    vm.$router.push({name: 'fulfillment_detail', params: {id: res.data}})
                })
                this.waitting = false

            },
            submitOrder: async function () {
                let vm = this
                this.waitting = true

                await this.$http.post(this.$config.api + 'fulfillment/submit', this.orders).then(function (res) {
                    vm.invoices = res.data
                    vm.step = 3
                })
                this.waitting = false
            },

            validateSku: async function () {
                this.invoices = []
                this.waitting = true
                this.showProcess = true
                let vm = this
                vm.step = 1
                this.processVal = 0
                let isValid = true
                for (let i = 0; i < this.orders.length; i++) {
                    this.processVal = this.processVal + 1
                    if (this.orders[i].validate == true) continue
                    let style = this.$_.find(this.design.styles, {'name': this.orders[i].style})

                    if (!style) {
                        vm.$set(vm.orders[i], 'validate', false)
                        vm.$set(vm.orders[i], 'validate_message', 'Invalid Style')
                        isValid = false
                        continue
                    }

                    if (style.size != null && this.orders[i].size == '') {
                        vm.$set(vm.orders[i], 'validate', false)
                        vm.$set(vm.orders[i], 'validate_message', 'Invalid Size')
                        isValid = false
                        continue
                    }

                    if (style.color != null && this.orders[i].color == '') {
                        vm.$set(vm.orders[i], 'validate', false)
                        vm.$set(vm.orders[i], 'validate_message', 'Invalid Color')
                        isValid = false
                        continue
                    }

                    if (parseInt(this.orders[i].quantity) < 1) {
                        vm.$set(vm.orders[i], 'validate', false)
                        vm.$set(vm.orders[i], 'validate_message', 'Invalid Quantity')
                        isValid = false
                        continue
                    }
                    //'shipping_name', 'shipping_address_1', 'shipping_address_2', 'shipping_city', 'shipping_state', 'shipping_zipcode', 'shipping_country',
                    if (this.orders[i].shipping_name == '' ||
                        this.orders[i].shipping_address_1 == '' ||
                        this.orders[i].shipping_city == '' ||
                        this.orders[i].shipping_state == '' ||
                        this.orders[i].shipping_zipcode == '' ||
                        this.orders[i].shipping_country == ''
                    ) {
                        vm.$set(vm.orders[i], 'validate', false)
                        vm.$set(vm.orders[i], 'validate_message', 'Invalid Shipping Information')
                        isValid = false
                        continue
                    }

                    await this.$http.post(this.$config.api + 'fulfillment/validate', this.orders[i]).then(function (res) {
                        if (res.data.code == 200) {
                            vm.$set(vm.orders[i], 'validate', true)
                        } else {
                            vm.$set(vm.orders[i], 'validate', false)
                            vm.$set(vm.orders[i], 'validate_message', res.data.message)
                            isValid = false
                        }
                    })


                }
                this.waitting = false
                this.showProcess = false
                this.validateOrder = isValid
                if (isValid) {
                    this.step = 2

                }

            },
            remove: function (item) {
                let vm = this
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You cant revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(async (result) => {
                    if (result.value) {
                        let id = item.order_id
                        let idx = vm.orders.indexOf(item)
                        vm.orders.splice(idx, 1);
                        this.$swal('Deleted', 'You successfully order ' + id, 'success')
                    } else {
                        this.$swal('Cancelled', 'Your order is still intact', 'info')
                    }
                })
            },
            downloadCSV: function () {
                let csv = []
                let vm = this
                csv.push(this.csvHeader)
                for (let i = 0; i < this.orders.length; i++) {
                    //  console.log(this.orders[i])
                    var result = Object.keys(this.orders[i]).map(function (key) {
                        return vm.orders[i][key];
                    });
                    csv.push(result)
                }
                // console.log(csv)
                this.$helper.exportToCsv('order-csv.csv', csv)
            },
            update: function (event) {
                //  this.item = event

                let idx = this.orders.indexOf(this.item)
                let keys = Object.keys(this.item);

                for (let i = 0; i < keys.length; i++) {
                    this.$set(this.orders[idx], keys[i], event[keys[i]])
                }
            },
            add: function (event) {
                //  this.item = event

                this.orders.push(event)
            },
            showAddModal() {
                if (this.waitting == true) return false

                this.modalTitle = 'Add Order'
                this.action = 'add'
                this.item = {
                    color: "",
                    order_id: "",
                    quantity: "",
                    shipping_address_1: "",
                    shipping_address_2: "",
                    shipping_city: "",
                    shipping_country: "",
                    shipping_email: "",
                    shipping_name: "",
                    shipping_phone: "",
                    shipping_state: "",
                    shipping_zipcode: "",
                    size: "",
                    sku: "",
                    style: "",
                }
                this.$refs.modalOrder.show()
            },
            showModal(item) {
                if (this.waitting == true) return false
                this.modalTitle = 'Edit Order'
                this.action = 'edit'
                this.item = item
                this.$refs.modalOrder.show()
            },
            hideModal() {
                this.$refs.modalOrder.hide()
            },
            handleFileUpload: function () {
                let formData = new FormData()
                let vm = this
                formData.append('file', this.file)

                this.$http.post(this.$config.api + 'fulfillment/upload',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function (res) {
                    if (res.data.code && res.data.code == 400) {
                        vm.$swal(res.data.message)
                        return false
                    }
                    vm.orders = res.data

                })
                    .catch(function () {
                        console.log('FAILURE!!');
                    });
            },
            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data

                    for (let i = 0; i < vm.design.styles.length; i++) {
                        vm.design.styles[i].price = parseFloat(vm.design.styles[i].base_cost) + 15;
                    }

                    vm.design.styles[0].isDefault = true
                });
            },

        }
    }
</script>

<style scoped lang="scss">
    .table-product {
        tr:hover {
            cursor: pointer;
            background-color: #eaeaea;
        }

        tr.selected {
            background-color: #99bb4642;


        }
    }

    .header {
        font-size: 0.7rem;
    }

    .item {
        font-size: 0.7rem;
        cursor: pointer;
    }


</style>